import { render, staticRenderFns } from "./changeModal.vue?vue&type=template&id=bb3e5610&scoped=true&"
import script from "./changeModal.vue?vue&type=script&lang=js&"
export * from "./changeModal.vue?vue&type=script&lang=js&"
import style0 from "./changeModal.vue?vue&type=style&index=0&id=bb3e5610&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3e5610",
  null
  
)

export default component.exports